import { render, staticRenderFns } from "./HorizontalCardBottom.vue?vue&type=template&id=cc895f62&scoped=true&"
import script from "./HorizontalCardBottom.vue?vue&type=script&lang=js&"
export * from "./HorizontalCardBottom.vue?vue&type=script&lang=js&"
import style0 from "./HorizontalCardBottom.vue?vue&type=style&index=0&id=cc895f62&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc895f62",
  null
  
)

export default component.exports